import { render } from "./manage-footer-branche.vue?vue&type=template&id=3300ff32"
import script from "./manage-footer-branche.vue?vue&type=script&lang=js"
export * from "./manage-footer-branche.vue?vue&type=script&lang=js"

import "./manage-footer-branche.vue?vue&type=style&index=0&id=3300ff32&lang=scss"

import exportComponent from "C:\\Users\\yrabie\\Documents\\Projects\\Awsat Admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__